import LOGO1 from '../assets/Affiliate/Logos Icons/quality-content_icon.jpg';
import LOGO2 from '../assets/Affiliate/Logos Icons/payout_icon.jpg';
import LOGO3 from '../assets/Affiliate/Logos Icons/latest-tools_icon.jpg';
import NN_LOGO from '../assets/Affiliate/Logos Icons/NN-logo.png';
import NN_LIVE_LOGO from '../assets/Affiliate/Logos Icons/NNLive_logo.png';
import FANZONE_LOGO from '../assets/Affiliate/Logos Icons/fanzone_logo.png';
import anchorBG1 from '../assets/Affiliate/marina-mobile.jpg';
import anchorBG2 from '../assets/Affiliate/isabella-mobile.jpg';
import anchorBG3 from '../assets/Affiliate/eila_mobile.jpg';


export const AFFILIATE_LOGIN_URL = 'https://nakednews.everflowclient.io/';

export const AFFILIATE_TEXT_MIDDLE = [
  {
    image: LOGO1,
    title: 'QUALITY CONTENT',
    desc: 'Naked News has \"nothing to hide\". With our high quality and exclusive offers, promoting top converting content has never been easier.',
  },
  {
    image: LOGO2,
    title: 'PAYOUT',
    desc: 'Competitive payouts. Start promoting with us to earn {affiliatePercentage} revenue share.',
  },
  {
    image: LOGO3,
    title: 'LATEST TOOLS',
    desc: 'Access the latest tools, including landing pages and banners for Naked News and FANZONE. Custom promotional content ideas? Speak to us!',
  },
];

export const AFFILIATE_TEXT_BOTTOM = [
  {
    backgroundImageMobile: anchorBG1,
    logo: NN_LOGO,
    desc: 'Stay entertained and informed with current events and special features - delivered completely naked by gorgeous anchors. Never miss breaking news, sports, weather and entertainment with Naked News.',
  },
  {
    backgroundImageMobile: anchorBG2,
    logo: FANZONE_LOGO,
    desc: 'Subscribe to FANZONE and get even closer to your favorite anchors. Access special content including videos and galleries, watch live streams and chat privately.',
  },
  {
    backgroundImageMobile: anchorBG3,
    logo: NN_LIVE_LOGO,
    desc: 'Subscribe to Naked News LIVE to enjoy weekly shows with the best selection of guests. Access all Naked News LIVE events and unlock a personal experience',
  },
];
